module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "book-pages---regular1"
  }, [_vm._v("With thanks to David Greagg (Duty Wombat and reason for existing); Ben Pryor, Shelley Robinson, Mark Pryor, Jade King, Patrizia di Biase, Themetrula Gardner, Helen Gordon-Clark, Mark Dolahenty, Patrick Burns, Vanessa Craigie, Cathy Collopy, Rita Battaglin, Daniel Barfoot, Winston B Todd, Tom Lane, Bill Collopy, Katie Purvis, Frank Mattea, Susan Tonkin, Woody, Marie Eleanor, Simon Johnson, Hugh Hunt and all my choral friends who sang rude pub songs with me and oratorios and masses and endless Christmas Carols and Laudate and “Wild Mountain Thyme”; my folk heroes Danny Spooner and Judy Small; and my mother, who sang my earliest song to me, to the percussion accompaniment of her heart.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77350a21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Acknowledgments.vue
// module id = 72
// module chunks = 0